import { render, staticRenderFns } from "./overview-home.vue?vue&type=template&id=c619f9fa&scoped=true&"
import script from "./overview-home.vue?vue&type=script&lang=js&"
export * from "./overview-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c619f9fa",
  null
  
)

export default component.exports